function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PaymentMethodPanel from "./PaymentMethodPanel";
import { anchorCdnUrl } from "../../constants";
const brandLogos = {
  jcb: 'jcb.svg',
  amex: 'amex.svg',
  visa: 'visa.svg',
  mastercard: 'mastercard.svg',
  discover: 'discover.svg',
  diners: 'diners-club.svg',
  unionpay: 'unionpay.svg'
};
const defaultCardLogo = 'default-card.svg';
export default function CreditCardPanel(props) {
  const {
    creditCard
  } = props;
  const {
    last4,
    creditCard: {
      brand,
      expiry
    }
  } = creditCard;
  return /*#__PURE__*/React.createElement(PaymentMethodPanel, _extends({}, props, {
    title: "Credit Card",
    description: "****".concat(last4).concat(expiry ? " (Expires ".concat(expiry.month, "/").concat(expiry.year, ")") : ''),
    logo: /*#__PURE__*/React.createElement("img", {
      alt: "credit card logo",
      "data-testid": "credit-card-logo",
      src: "".concat(anchorCdnUrl, "/images/credit-cards/").concat(brandLogos[brand] || defaultCardLogo)
    })
  }));
}